const pageNameKey = "machinesListWithCompanies";

export const machinesListWithCompaniesEn = {
  [pageNameKey]: {
    machines: "Machines",
    machine: "Machine",
    gateWayIcon: "Gateway Icon",
    noDataAvailable: "No data available",
    machinesListEmptyInfoText: "No Machines detected, yet!",
  },
};

export const machinesListWithCompaniesPtBr = {
  [pageNameKey]: {
    machines: "Máquinas",
    machine: "Máquina",
    gateWayIcon: "Ícone do Gateway",
    noDataAvailable: "Nenhum dado disponível",
    machinesListEmptyInfoText: "Até o momento nenhuma máquina detectada",
  },
};

export const machinesListWithCompaniesDe = {
  [pageNameKey]: {
    machines: "Maschinen",
    machine: "Maschine",
    gateWayIcon: "Gateway-Symbol",
    noDataAvailable: "Keine Daten verfügbar",
    machinesListEmptyInfoText: "Noch keine Maschinen erkannt!",
  },
};

export const machinesListWithCompaniesZhHans = {
  [pageNameKey]: {
    machines: "机器",
    machine: "机器",
    gateWayIcon: "网关图标",
    noDataAvailable: "无可用数据",
    machinesListEmptyInfoText: "尚未检测到机器！",
  },
};

export const machinesListWithCompaniesIt = {
  [pageNameKey]: {
    machines: "Macchine",
    machine: "Macchina",
    gateWayIcon: "Icona Gateway",
    noDataAvailable: "Nessun dato disponibile",
    machinesListEmptyInfoText: "Nessuna macchina rilevata finora!",
  },
};

export const machinesListWithCompaniesEs = {
  [pageNameKey]: {
    machines: "Máquinas",
    machine: "máquina",
    gateWayIcon: "Icono de gateway",
    noDataAvailable: "No hay datos disponibles",
    machinesListEmptyInfoText: "¡Aún no se han detectado máquinas!",
  },
};

export const machinesListWithCompaniesNl = {
  [pageNameKey]: {
    gateWayIcon: "Gateway-pictogram",
    machine: "Machine",
    machines: "Machines",
    machinesListEmptyInfoText: "Nog geen machines gedetecteerd!",
    noDataAvailable: "Geen gegevens beschikbaar",
  },
};

export const machinesListWithCompaniesTr = {
  [pageNameKey]: {
    gateWayIcon: "Ağ Geçidi Simgesi",
    machine: "Makine",
    machines: "Makineler",
    machinesListEmptyInfoText: "Henüz hiçbir Makine algılanmadı!",
    noDataAvailable: "Veri yok",
  },
};
